import Chip from "@mui/material/Chip";
import { useEffect, useState } from "react";
import { FaRegCalendarAlt, FaRegClock } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import { Form, Button, Row, Col, } from "react-bootstrap";
import { MultiSelect } from "react-multi-select-component";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import { FaFilePdf, FaEye } from "react-icons/fa";
import { TiDelete } from "react-icons/ti";
import schoolServices from "../../../services/school_services";
import { showSuccessMessage, showErrorMessage } from "../../../services/utils";
import LoadingBar from "../toaster/loader/loader";
import { getSchoolSharedDoc, getHospitalSharedDoc } from "../../../services/utils";

const RotationReq = (props) => {
    const navigate = useNavigate()
    let UserRole = localStorage.getItem("PageTittle")
    const [modalOpen, setModalOpen] = useState(false)
    const [studentList, setstudentList] = useState([])
    const [selected, setSelected] = useState([])
    const [rotationData, setRotationData] = useState()
    const [imageFile, setImageFile] = useState()
    const [school_id, setSchool_id] = useState()
    const [program_id, setProgram_id] = useState()
    const [istrctrDtls, setInstrctDtls] = useState({ name: "", email: "", phone: "" })
    const [loadin, setloadin] = useState(false)
    // useEffect(() => {
    //     if (props?.studentList) {
    //         props?.studentList.length > 0 && props.studentList.map(curr => {
    //             setstudentList(prevState => ([...prevState,
    //             {
    //                 label: curr.first_name + " " + curr.last_name,
    //                 value: curr.user_id
    //             }]))
    //         })
    //     }
    // }, [props.studentList])

    const addRotationDetail = (e) => {
        let Ids = []
        setloadin(true)
        if (selected.length > 0) {
            selected.map(curr => {
                Ids.push(curr.value)
            })
        }
        const form_data = new FormData()
        for (var key in istrctrDtls) {
            form_data.append(key, istrctrDtls[key]);
        }
        form_data.append("image", rotationData?.rotationRequestDetatil?.image ? rotationData?.rotationRequestDetatil?.image : imageFile)
        form_data.append("student_ids", JSON.stringify(Ids))
        form_data.append("rotation_req_id", rotationData._id)


        schoolServices.UpdateRotationDetails(form_data).then(resp => {
            setModalOpen(false)
            setloadin(false)
            setSelected([])
            showSuccessMessage({ message: "Request Submitted" })
        }).catch(err => {
            setloadin(false)
            showErrorMessage({ message: "Submission Failed" })
        })
        e.preventDefault()

    }

    const DownLoadDoc = (e) => {
        const body = {
            document: e,
            type: "request_detail",
        }
        if (UserRole === "School") {
            getSchoolSharedDoc(body).then(resp => {
                window.open(resp.data.data.signedUrl);
            })
        }
        else if (UserRole === "Hospital") {
            getHospitalSharedDoc(body).then(resp => {
                window.open(resp.data.data.signedUrl);
            })
        }
    }

    const handleChange = (e) => {
        setInstrctDtls({
            ...istrctrDtls,
            [e.target.name]: e.target.value
        })
    }


    const getStudentList = (res) => {
        setstudentList([])
        schoolServices.getBatchStudentlist({ school_id: res.school_id, program_id: res.program_id }).then(resp => {
            resp.data.data && resp.data.data.length > 0 && resp.data.data.map(curr => {
                setstudentList(prevState => ([...prevState,
                {
                    label: curr.first_name + " " + curr.last_name,
                    value: curr.user_id
                }]))
            })
            // setUtilityList(prev => ({ ...prev, "studentList": resp.data.data }))
        }
        )
    }
    return (
        <div className="apnt_cards_wrp">
            {loadin &&
                <LoadingBar />
            }
            {
                props.UtilityList && props.UtilityList.length > 0 ? props.UtilityList.map(res => {
                    const startDate = new Date(res.start_date)
                    const endDate = new Date(res.end_date)
                    const slocal = startDate.toLocaleDateString();
                    const elocal = endDate.toLocaleDateString();

                    return (
                        <div className="apnt_card mb-3" onClick={() => {
                            res.status == "approved" &&
                                setModalOpen(!modalOpen)
                            setRotationData(res)
                            getStudentList(res)
                            if (res.rotationRequestDetatil) {
                                res.rotationRequestDetatil?.studentInfos.length > 0 && res.rotationRequestDetatil.studentInfos.map(curr => {
                                    setSelected(prevState => ([...prevState,
                                    {
                                        label: curr.first_name + " " + curr.last_name,
                                        value: curr.user_id
                                    }]))
                                })
                            }
                        }}>
                            <Chip
                                label={res.status.toUpperCase()}
                                color={res.status === 'approved' ? 'success' : res.status === 'disapproved' ? "error" : "warning"}
                                size="small"
                                className="schl_bdg"
                            />
                            {
                                UserRole == "Hospital" ? <h5 className="mb-2">{res.schoolData.school_name.toUpperCase()}</h5>
                                    :
                                    <h5 className="mb-2">{res.hospitalInfo.hospital_name.toUpperCase()}</h5>
                            }

                            {/* <p>Surgical department</p> */}
                            {
                                UserRole == "Hospital" ? <h6 className="stud_hosp mb-3">{res?.departmentInfo?.department.toUpperCase()}</h6>
                                    :
                                    <h6 className="stud_hosp mb-3">{res.departmentInfo?.department.toUpperCase()}</h6>
                            }

                            <div className="schdl_dt d-flex align-items-center mb-2">
                                <div className="schdl_icn ftr_icn">
                                    <FaRegCalendarAlt />
                                </div>
                                <span>
                                    {`${slocal} - ${elocal}`}
                                </span>
                            </div>
                            <div className="schdl_dt d-flex align-items-center">
                                <div className="schdl_icn ftr_icn">
                                    <FaRegClock />
                                </div>
                                <span>
                                    {`${res.start_time}-${res.end_time}`}
                                </span>
                            </div>
                        </div>
                    )
                }) :
                    <div className="apnt_card mb-3">
                        <Chip
                            label="Processing"
                            color="primary"
                            size="small"
                            className="schl_bdg"
                        />
                        <h5>No Data Found</h5>
                    </div>

            }
            <Modal oncl show={modalOpen} onHide={() => {
                setSelected([])
                setModalOpen(false)
            }} className="main_modl">
                <Modal.Header closeButton>
                    <Modal.Title className="text_theme">
                        Rotation Request Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="inner_rotaion">
                    <div className="prfl_flds">
                        <Form onSubmit={(e) => { addRotationDetail(e) }}>
                            <Form.Group
                                controlId="formFile"
                                className="mb-3"
                            >
                                <Row className="mb-3">
                                    <Col sm={4}>
                                        <h6 className="text-grey">Date From</h6>
                                    </Col>
                                    <Col sm={8}>
                                        <h6 className="textModify">:<span className="tym_fm">{moment(rotationData?.start_date).format("MMM-DD-YYYY")} to {moment(rotationData?.end_date).format("MMM-DD-YYYY")}</span></h6>
                                    </Col>
                                </Row>
                                {/* <div className="div_inner_add">
                                    <p className="me-2">
                                        Date From :
                                        <span className="">{moment(rotationData?.start_date).format("MMM-DD-YYYY")} to {moment(rotationData?.end_date).format("MMM-DD-YYYY")}</span>
                                    </p>
                                </div> */}

                                <Row className="mb-3">
                                    <Col sm={4}>
                                        <h6 className="text-grey">Time from </h6>
                                    </Col>
                                    <Col sm={8}>
                                        <h6 className="textModify">: <span className="tym_fm">{rotationData?.start_time}</span> to <span>{rotationData?.end_time}</span></h6>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <h6 className="text-grey">Rotation Request </h6>
                                    </Col>
                                    <Col sm={8}>
                                        <h6 className="textModify">: <span className="tym_fm">{rotationData?.status}</span></h6>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <h6 className="text-grey">Rotation Type</h6>
                                    </Col>
                                    <Col sm={8}>
                                        <h6 className="textModify">: <span className="tym_fm">{rotationData?.departmentInfo?.department} </span></h6>
                                    </Col>
                                </Row>
                                {
                                    UserRole == "School" &&
                                    <>
                                        <Form.Label>
                                            Select Student
                                        </Form.Label>
                                        <MultiSelect
                                            overrideStrings={{
                                                "allItemsAreSelected": "All Students are selected.",
                                                "noOptions": "No Students available",
                                                "search": "Search for Students",
                                                "clearSearch": "Clear Search",
                                                "clearSelected": "Clear Selected",
                                                "selectAll": "Select All Students",
                                                "selectAllFiltered": "Select All (Filtered)",
                                                "selectSomeItems": "Select...",
                                                "create": "Create",
                                            }}
                                            className="multi_slct"
                                            options={studentList}
                                            value={selected}
                                            onChange={(e) => {
                                                setSelected(e)
                                            }}
                                            labelledBy="Select"
                                        />
                                    </>
                                }

                                {
                                    UserRole == "Hospital" &&
                                    <>
                                        <Form.Label>
                                            Student List
                                        </Form.Label>
                                        <div className="div_list">
                                            <ol>
                                                {
                                                    rotationData?.rotationRequestDetatil && rotationData?.rotationRequestDetatil.studentInfos && rotationData?.rotationRequestDetatil.studentInfos.map(curr => {
                                                        return (
                                                            <li>
                                                                <p className="mb-1">{curr.first_name + " " + curr.last_name} <FaEye onClick={() => { navigate(`/student-files/${curr.user_id}`) }} style={{ marginLeft: "115px" }} /></p>
                                                            </li>
                                                        )
                                                    })
                                                }

                                            </ol>
                                        </div>
                                    </>

                                }
                                {UserRole == "School" &&
                                    <>
                                        <div className="mb-3">
                                            <Form.Label className="mt-3">
                                                Upload Instructor Picture
                                            </Form.Label>
                                            <Form.Control name='prior_certifications_proof' type="file"
                                                onChange={(e) => { setImageFile(e.target.files[0]) }}
                                                required={rotationData?.rotationRequestDetatil?.image ? false : true}
                                                accept=".jpg,.png,.jpeg"
                                            />
                                        </div>


                                    </>


                                }
                                {(UserRole == "Hospital" || UserRole == "School") &&
                                    rotationData?.rotationRequestDetatil && rotationData?.rotationRequestDetatil?.image &&
                                    <>
                                        <Form.Label className="mt-3">
                                            Instructor Picture
                                        </Form.Label>
                                        <div className="file_div dlt_file d-flex align-items-center">
                                            <div onClick={() => { DownLoadDoc(rotationData?.rotationRequestDetatil?.image) }} className="fl_icn">
                                                <FaFilePdf />
                                            </div>
                                            <div className="fl_txt" onClick={() => { DownLoadDoc(rotationData?.rotationRequestDetatil?.image) }}>
                                                <p
                                                >
                                                    {rotationData?.rotationRequestDetatil?.image}
                                                </p>
                                            </div>
                                            <div onClick={() => {
                                                //     setRotationData(prevState => ({
                                                //         ...prevState,
                                                //         [rotationData.rotationRequestDetatil.image]: null
                                                //    }))
                                                // setRotationData({...rotationData, [rotationData.rotationRequestDetatil.image]:""})
                                            }} className="fl_icn dlt_icn ms-2 me-0">
                                                <TiDelete />
                                            </div>
                                        </div>
                                    </>

                                }

                                {(UserRole == "Hospital" || UserRole == "School") &&
                                    <div className="mb-3">
                                        <Form.Label className="mt-3">
                                            Instructor Name
                                        </Form.Label>
                                        <Form.Control name='name' type="text"
                                            onChange={handleChange}
                                            disabled={UserRole == "School" ? false : true}
                                            defaultValue={rotationData?.rotationRequestDetatil?.name}
                                            required={rotationData?.rotationRequestDetatil?.name ? false : true}
                                        />
                                        <Form.Label className="mt-3">
                                            Instructor E-mail
                                        </Form.Label>
                                        <Form.Control name='email' type="text"
                                            onChange={handleChange}
                                            disabled={UserRole == "School" ? false : true}
                                            defaultValue={rotationData?.rotationRequestDetatil?.email}
                                            required={rotationData?.rotationRequestDetatil?.email ? false : true}
                                        />
                                        <Form.Label className="mt-3">
                                            Instructor Phone
                                        </Form.Label>
                                        <Form.Control name='phone' type="number"
                                            onChange={handleChange}
                                            disabled={UserRole == "School" ? false : true}
                                            defaultValue={rotationData?.rotationRequestDetatil?.phone}
                                            required={rotationData?.rotationRequestDetatil?.phone ? false : true}
                                        />
                                    </div>

                                }
                            </Form.Group>
                            {UserRole == "School" &&

                                <div className="text-center">
                                    <Button
                                        className="btn_theme mt-4"
                                        variant=""
                                        type="submit"

                                    >
                                        Save
                                    </Button>
                                </div>

                            }

                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </div>

    )
}

export default RotationReq